import { Chip } from '@mui/material';

export default function ServiceBadge({ label, color = 'primary' }) {
  return <Chip color={color} label={label} />;
}
